module.exports = __webpack_public_path__ + "img/MoonRat_2x.da4b45e7.png";